<div
  class="small-word"
  [ngClass]="{
    'ddc-small-word-light': _isLightTheme || _isPaperTheme,
    'ddc-small-word-dark': _isDarkTheme,
  }"
>
  <div class="small-word-1" *ngIf="_withIcon">
    <span class="material-icons ddc-chip-icon"> fiber_manual_record </span>
  </div>
  <div class="small-word-2">
    <div class="truncate max-w-[200px]">{{ _word.word ? _word.word : _word }}</div>
  </div>
</div>
